import { useAuthStore } from '@/store/auth.store'
import type { PermissionKey } from '@/types/permission.types'

export function useAuth() {
  const session = useAuthStore((s) => s.session)
  const isAuthenticated = useAuthStore((s) => s.isAuthenticated)
  const isHydrated = useAuthStore((s) => s.isHydrated)
  const login = useAuthStore((s) => s.login)
  const logout = useAuthStore((s) => s.logout)
  const hasPermission = useAuthStore((s) => s.hasPermission)
  const hasRole = useAuthStore((s) => s.hasRole)

  return {
    user: session?.user ?? null,
    session,
    isAuthenticated,
    isHydrated,
    login,
    logout,
    hasPermission,
    hasRole,
  }
}

export function usePermission(key: PermissionKey): boolean {
  return useAuthStore((s) => s.hasPermission(key))
}

export function usePermissions() {
  const permissions = useAuthStore((s) => s.session?.user.permissions)
  const role = useAuthStore((s) => s.session?.user.role)
  const hasPermission = useAuthStore((s) => s.hasPermission)
  return { permissions, role, hasPermission }
}
